import React from 'react';
import { ErrorPage } from '../../pages/ErrorPage/ErrorPage';

interface ErrorBoundaryProps {
    hasError: boolean;
    error: string;
}
export class ErrorBoundary extends React.Component<{}, ErrorBoundaryProps> {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: '' };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: error.toString() };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.log('error is: ', error);
        // eslint-disable-next-line no-console
        console.log('info is: ', info);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <ErrorPage statusCode={404} message={this.state.error} />;
        }

        // If there is no error just render the children component.
        return (
            <React.Suspense fallback={<div>Loading...</div>}>{this.props.children}</React.Suspense>
        );
    }
}
